const locale = {
    placeholder: 'Vybrat čas',
};
export default locale;
